import type {
	Components,
} from '@mui/material'

export const materialUIInputTheme: {
	components: Components
} = {
	components: {
		MuiTextField: {
			defaultProps: {
				size: 'medium',
			},
			styleOverrides: {
				root: {
					padding: '0 !important',

					/* label */
					'& .MuiInputLabel-root': {
						color:      'var(--on-surface-color-hint)',
						fontWeight: 'var(--font-weight-regular)',

						'&.Mui-focused': {
							color: 'var(--primary-color)',
						},
					},

					// /* label shrinked */
					// '& .MuiInputLabel-root[data-shrink="true"]:not(.Mui-error)': {
					// 	color:      'var(--primary-color)',
					// 	fontWeight: 'var(--font-weight-medium)',
					// },

					'& .MuiInputBase-root': {
						'& .MuiInputBase-input': {
							color:      'var(--on-surface-color)',
							fontSize:   'var(--font-size-body-x-small)',
							// CHANGE IT
							padding:    '12px 6px',
							transition: 'opacity 0.2s ease-in-out',

							'&::placeholder': {
								color:      'var(--on-surface-color-hint)',
								fontSize:   'var(--font-size-body-small)',
							},
						},
					},

					'& .MuiOutlinedInput-notchedOutline': {
						backgroundColor: 'var(--surface-container-color)',
						borderRadius:    'var(--border-radius-m)',
					},

					'&:hover': {
						'& .MuiInputBase-input': {
							'&::placeholder': {
								opacity: 0.7,
							},
						},
					},
				},
			},
			variants: [
				{
					props: {
						variant: 'outlined',
					},
					style: {

						/* label */
						'& .MuiInputLabel-root': {
							color: 'var(--on-surface-color-hint)',
						},
						'& .MuiInputLabel-root.Mui-error': {
							color: 'var(--error-color)',
						},

						/* root */
						'& .MuiInputBase-root': {
							'&.Mui-error .MuiSvgIcon-root': {
								color: 'var(--error-color)',
							},

							'&:hover:not(.Mui-error)': {
								'& .MuiOutlinedInput-notchedOutline': {
									borderColor: 'var(--primary-color)',
								},
							},
						},

						/* hover (error) */
						'&:hover:not(.Mui-error)': {
							'& .MuiSvgIcon-root': {
								color: 'var(--primary-color)',
							},
						},

						/* hover (without error) */
						'&:hover:has(.Mui-error)': {
							'& .MuiSvgIcon-root': {
								color: 'var(--error-color)',
							},
						},

						/* filled (with value) */
						'&:has(.MuiInputBase-input[value]:not([value=""])):not(:has(.MuiInputBase-root.Mui-error))': {
							'& .MuiSvgIcon-root': {
								color: 'var(--primary-color)',
							},

							'& .MuiInputLabel-root': {
								color: 'var(--primary-color)',
							},

							'& .MuiOutlinedInput-notchedOutline': {
								border: '2px solid var(--primary-color)',
							},
						},

						/* filled (with value) fix for textarea */
						'&:has(textarea.MuiInputBase-input:not(:empty)):not(:has(.MuiInputBase-root.Mui-error))': {
							'& .MuiOutlinedInput-notchedOutline': {
								border: '2px solid var(--primary-color)',
							},
						},

						/* root error */
						'& .MuiInputBase-root.Mui-error': {
							'& .MuiOutlinedInput-notchedOutline': {
								border: `2px solid var(--error-color)`,
							},
							'& .MuiSvgIcon-root': {
								color: 'var(--error-color)',
							},
						},

						/* focus (error) */
						'& .MuiInputBase-root.Mui-focused.Mui-error': {
							'& .MuiOutlinedInput-notchedOutline': {
								borderColor: 'var(--error-color)',
							},
							'& .MuiSvgIcon-root': {
								color: 'var(--error-color)',
							},
						},

						/* focus (without error) */
						'& .MuiInputBase-root.Mui-focused:not(.Mui-error)': {
							'& .MuiOutlinedInput-notchedOutline': {
								borderColor: 'var(--primary-color)',
							},
							'& .MuiSvgIcon-root': {
								color: 'var(--primary-color)',
							},
						},

						/* fieldset */
						'& .MuiOutlinedInput-notchedOutline': {
							transition: 'border-color 0.1s ease',
							border:     'var(--outline-base)',
							background: 'none',
						},
					},
				},
			],
		},
		MuiInputAdornment: {
		},
	},
}
